// Word banks for the name generator pages. Authored lists, no scraping, no real
// people. Fantasy names are assembled from syllables so the output space is much
// larger than the bank itself.

export const ADJECTIVES = [
  'brave',
  'quiet',
  'clever',
  'golden',
  'silent',
  'lucky',
  'wild',
  'gentle',
  'rapid',
  'cosmic',
  'amber',
  'frosty',
  'sunny',
  'velvet',
  'crimson',
  'hidden',
  'noble',
  'swift',
  'lunar',
  'electric',
  'humble',
  'curious',
  'mellow',
  'stormy',
  'bright',
  'copper',
  'nimble',
  'radiant',
  'salty',
  'wandering',
];

export const NOUNS = [
  'otter',
  'falcon',
  'cedar',
  'comet',
  'harbor',
  'lantern',
  'meadow',
  'panther',
  'quartz',
  'raven',
  'summit',
  'thunder',
  'willow',
  'anchor',
  'badger',
  'canyon',
  'ember',
  'fjord',
  'glacier',
  'heron',
  'island',
  'jasper',
  'kestrel',
  'lynx',
  'monsoon',
  'nebula',
  'orchid',
  'pilot',
  'quill',
  'ridge',
];

export const FIRST_NAMES = [
  'Alma',
  'Bruno',
  'Cleo',
  'Dario',
  'Elsa',
  'Felix',
  'Greta',
  'Hugo',
  'Ines',
  'Jonas',
  'Kira',
  'Leon',
  'Mila',
  'Nadia',
  'Oscar',
  'Petra',
  'Quinn',
  'Rosa',
  'Simon',
  'Tessa',
  'Ulric',
  'Vera',
  'Wanda',
  'Xavier',
  'Yara',
  'Zane',
  'Ada',
  'Boris',
  'Celia',
  'Dmitri',
  'Edda',
  'Franz',
  'Gita',
  'Helga',
  'Ivo',
  'Juno',
];

export const LAST_NAMES = [
  'Alvarez',
  'Bennett',
  'Castillo',
  'Dietrich',
  'Ellery',
  'Fontaine',
  'Gallagher',
  'Halvorsen',
  'Iversen',
  'Janssen',
  'Kowalski',
  'Lindqvist',
  'Moreau',
  'Novak',
  'Okafor',
  'Pereira',
  'Quintana',
  'Rasmussen',
  'Sokolov',
  'Tanaka',
  'Ueda',
  'Vasquez',
  'Whitfield',
  'Yamada',
  'Zielinski',
  'Ashford',
  'Brennan',
  'Chandler',
  'Duarte',
  'Eriksen',
];

export const NICK_PREFIXES = [
  'Ace',
  'Blaze',
  'Chill',
  'Dash',
  'Echo',
  'Flint',
  'Ghost',
  'Hawk',
  'Iron',
  'Jet',
  'Koda',
  'Lucky',
  'Maverick',
  'Nova',
  'Onyx',
  'Pixel',
  'Quick',
  'Rogue',
  'Shadow',
  'Turbo',
  'Vibe',
  'Wolf',
  'Zen',
  'Cosmo',
];

export const NICK_SUFFIXES = [
  'ster',
  'zilla',
  'boss',
  'wave',
  'core',
  'byte',
  'storm',
  'fox',
  'bear',
  'hawk',
  'nova',
  'dash',
  'beam',
  'craft',
  'punk',
  'kid',
];

// Fantasy syllables: onset, middle, coda. Combined to build pronounceable names.
export const FANTASY_ONSETS = [
  'Ael',
  'Bra',
  'Cor',
  'Dae',
  'Eir',
  'Fen',
  'Gor',
  'Hal',
  'Ith',
  'Kael',
  'Lor',
  'Mor',
  'Nyx',
  'Orn',
  'Pyr',
  'Quor',
  'Rhen',
  'Syl',
  'Thal',
  'Ul',
  'Vor',
  'Wren',
  'Xan',
  'Yre',
  'Zar',
];

export const FANTASY_MIDDLES = [
  'a',
  'e',
  'i',
  'o',
  'ae',
  'ia',
  'or',
  'an',
  'el',
  'ur',
  'ys',
  'ath',
  'ir',
  'on',
];

export const FANTASY_CODAS = [
  'wyn',
  'dor',
  'mir',
  'thas',
  'ion',
  'reth',
  'gar',
  'lith',
  'vane',
  'kar',
  'sil',
  'dell',
  'nor',
  'quen',
  'rath',
  'wen',
];

export const FANTASY_TITLES = [
  'of the Ashen Vale',
  'the Untamed',
  'Stormborn',
  'of Hollow Reach',
  'the Twice-Named',
  'Emberkin',
  'of the Long Winter',
  'the Wandering',
  'Nightwarden',
  'of Silver Hollow',
];
